import api from './base-api';
import {
	BulkUpdateSlatesDto,
	CreateSlateDto,
	RefreshSlateMatchesDto,
	UpdateSlateDto,
	getSlatesDto,
	PullSessionSlateDto,
} from '@sportspredict/shared';

const slateApi = api.injectEndpoints({
	endpoints: (builder) => ({
		refreshMatches: builder.mutation<void, RefreshSlateMatchesDto>({
			query: (data) => ({
				url: `slates/refresh-matches`,
				method: 'POST',
				body: data,
			}),
			invalidatesTags: ['Slate'],
		}),
		pullSlates: builder.mutation({
			query: (data: getSlatesDto) => ({
				url: `slates/pull-slates`,
				method: 'POST',
				body: data,
			}),
			invalidatesTags: [{ type: 'Slate', id: 'LIST' }],
		}),
		createSlate: builder.mutation<{ id: string }, CreateSlateDto>({
			query: (data) => ({
				url: 'slates',
				method: 'POST',
				body: data,
			}),
			invalidatesTags: [{ type: 'Slate', id: 'LIST' }],
		}),
		pullSessionSlate: builder.mutation({
			query: (data: PullSessionSlateDto) => ({
				url: `slates/pull-session-slate`,
				method: 'POST',
				body: data,
			}),
			invalidatesTags: [{ type: 'Slate', id: 'LIST' }],
		}),
		updateSlate: builder.mutation<void, UpdateSlateDto>({
			query: ({ id, ...rest }) => ({
				url: 'slates',
				method: 'PUT',
				body: { id, ...rest },
			}),
			invalidatesTags: ['Slate'],
		}),
		deleteSlate: builder.mutation<void, string>({
			query: (id) => ({
				url: `slates/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['Slate'],
		}),
		bulkUpdateSlates: builder.mutation<void, BulkUpdateSlatesDto>({
			query: (data) => ({
				url: 'slates/all',
				method: 'PATCH',
				body: data,
			}),
			invalidatesTags: ['Slate'],
		}),
	}),
});

export const {
	usePullSlatesMutation,
	useRefreshMatchesMutation,
	usePullSessionSlateMutation,
	useCreateSlateMutation,
	useUpdateSlateMutation,
	useDeleteSlateMutation,
	useBulkUpdateSlatesMutation,
} = slateApi;
